import tmhRequest from '@/config/tmhRequest'

export default {
    searchPerferenceInfo: function (data) {
        return tmhRequest({
            url: '/customer/tmh/perferenceinfo/searchperferenceinfo',
            method: 'post',
            params: data,
        })
    },

    searchPerferenceResult: function (data) {
        return tmhRequest({
            url: '/customer/tmh/perferenceinfo/searchperferenceresult',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/perferenceinfo.js